import { WEB_PUSH } from 'constants/messageMediums';
import BaseSendEditor, { BaseSendEditorProps } from '../BaseSendEditor';

export const SendWebPushEditor = (props: BaseSendEditorProps) => {
  return (
    <BaseSendEditor
      shouldShowDeliverySectionHeader
      shouldShowQuietHours
      shouldShowRateLimit
      {...props}
      messageMedium={WEB_PUSH}
    />
  );
};
